<template>
  <div>
    <shared-inbound-select-members @selectMember="selectMember" :members="members"></shared-inbound-select-members>
  </div>
</template>

<script>
import SharedInboundSelectMembers from '@/views/Shared/Consultations/SelectMembers'

import Member from '@/models/Member'

export default {
  name: 'Window.Consultation.SelectMembers',
  components: {
    SharedInboundSelectMembers
  },
  data () {
    return {
      members: {},
      phone_number: '',
      ext_no: '',
      ring_gr: '',
      uniqueid: '',
      chanel: '',
      ivr_number: '',
      server: ''
    }
  },
  mounted () {

    this.phone_number = this.$route.query.phone_no
    this.ext_no = this.$route.query.ext_no
    this.ring_gr = this.$route.query.ring_gr
    this.uniqueid = this.$route.query.uniqueid
    this.chanel = this.$route.query.chanel
    this.ivr_number = this.$route.query.ivr_number
    this.server = this.$route.query.server

    this.$windowOpenerHelper.listenToPopUpMessage('close_inbound_select_member', this.closeInboundSelectMember)

    this.loadMembers()

  },
  methods: {
    async loadMembers () {
      const response = await Member.getMembers(this.phone_number)
      this.members = response.data.members
    },
    closeInboundSelectMember () {
      window.opener.location.reload()
      window.close()
    },
    windowConfigGenerate (object) {
      const string = []

      for (const i in object) {
        string.push(`${i}=${object[i]}`)
      }

      return string.join(', ')
    },
    centerPopUpPosition (width, height) {
      const top = (window.top.outerHeight / 2) + window.top.screenY - (height / 2)
      const left = (window.top.outerWidth / 2) + window.top.screenX - (width / 2)
      return this.windowConfigGenerate({ width, height, top, left })
    },
    selectMember (memberId) {

      const windowConfig  = this.centerPopUpPosition(980, 740)

      let params = []
      if (this.phone_number) {
        params.push(`phone_no=${this.phone_number}`)
      }

      if (this.ext_no) {
        params.push(`ext_no=${this.ext_no}`)
      }

      if (this.ring_gr) {
        params.push(`ring_gr=${this.ring_gr}`)
      }

      if (this.uniqueid) {
        params.push(`uniqueid=${this.uniqueid}`)
      }

      if (this.chanel) {
        params.push(`chanel=${this.chanel}`)
      }

      if (this.ivr_number) {
        params.push(`ivr_number=${this.ivr_number}`)
      }

      if (this.server) {
        params.push(`server=${this.server}`)
      }

      if (this.modal_id) {
        params.push(`modal_id=${this.modal_id}`)
      }

      if (this.title) {
        params.push(`title=${this.title}`)
      }
      if (memberId) {
        params.push(`memberId=${memberId}`)
      }

      params = params.join('&', params)
      window.open(`/window/inbound?${params}`, '', windowConfig)
    }
  }
}
</script>

<style scoped>

</style>
